import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Report } from '../../../icons';
import { useReportAdapter } from './useReportAdapter';
import { useStyles } from './useStyles';

export const ReportAdapter = memo(({ value, selected, onClick, className }) => {
    const { count, sended, handleClick } = useReportAdapter(value, onClick);
    const { t: translate } = useTranslation();
    const classes = useStyles();

    return (
        <ListItem onClick={handleClick} button={true} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Report
                    width="24"
                    height="24"
                    className={count > 0 ? (sended === count ? classes.statusSend : classes.statusEdit) : null}
                />
            </ListItemIcon>
            <ListItemText primary={translate('labels.reports')} className={className} />
        </ListItem>
    );
});

ReportAdapter.displayName = 'ReportAdapter';
